import pagination from "../static/pagination";
import exportData from '../static/exportData';

const moduleName = "invoiceModule";

const state = {
    isLoadMore: false,
    isFilter: false,
    response: {},
    exportData: exportData(),
    exportProgress: {
        processed: 0,
        total: 0,
    },

    isCheckAll: true,
    selectedTransaksi: [],
    unSelectedTransaksi: [],
    invoiceData: {
        dataInvoice: {
            idkaryawan: "",
            namaKaryawan: "",
            namaOutlet: "",
        },
    },
    reminders:[],

    invoiceList: [],
    invoiceTotal: 0,
    invoiceShow: [],
    invoiceView: {},
    invoiceEnd: {},
    invoicePage: pagination(),

    transaksiList: [],
    transaksiTotal: 0,
    grandTotal: 0,
    grandTotalCheck: 0,
    transaksiShow: [],
    transaksiView: {},
    transaksiEnd: {},
    transaksiPage: pagination(),

    konsumenList: [],
    konsumenTotal: 0,
    konsumenShow: [],
    konsumenView: {},
    konsumenEnd: {},
    konsumenPage: pagination(),
    listKonsumenSchedule: [],
    penjadwalanDetail: {},
    penjadwalanList: {
        count: 0,
        data: []
    },
    dataModal: {},
    mcoinEstimation: {},
};
export { state as default, moduleName };
